import * as React from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { useSessionExpired } from "@/contexts/SessionExpiredContext";

/**
 * Modal shown when the user's session expires (API 401 or Clerk sign-out on a protected route).
 * Based on @reui/c-dialog-10 — no dismiss control; user must sign in again.
 */
export function SessionExpiredDialog(): React.ReactElement {
  const { open, reason, signInAgain } = useSessionExpired();

  const signedInElsewhere = reason === "signed_in_elsewhere";

  return (
    <Dialog open={open} onOpenChange={() => undefined}>
      <DialogContent
        showCloseButton={false}
        onPointerDownOutside={(event) => event.preventDefault()}
        onEscapeKeyDown={(event) => event.preventDefault()}
        data-session-expired-dialog=""
      >
        <DialogHeader>
          <DialogTitle className="font-[family-name:var(--font-primary)] text-[color:var(--brand-tropical-surf)]">
            Session Expired
          </DialogTitle>
          <DialogDescription>
            {signedInElsewhere
              ? "You were signed out because you signed in on another device. Please sign in again to continue."
              : "Your session has timed out due to inactivity. Please sign in again to continue where you left off."}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button
            type="button"
            variant="gradient"
            size="sm"
            data-font="primary"
            className="w-full"
            onClick={signInAgain}
          >
            <span className="normal-case tracking-normal">Sign In Again</span>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
